import { render, staticRenderFns } from "./PurchaseReturn.vue?vue&type=template&id=319ce6e3&scoped=true"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReturn.vue?vue&type=style&index=0&id=319ce6e3&prod&lang=css"
import style1 from "./PurchaseReturn.vue?vue&type=style&index=1&id=319ce6e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319ce6e3",
  null
  
)

export default component.exports